'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Calendar_module = require('../styles/Calendar.module.less.js');
var date = require('../utils/date.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Day = (props) => {
    const { date: date$1, active, disabled, highlighted, today, className, onChange, ...restProps } = props;
    const cx = reactUtils.useStyles(Calendar_module.default);
    const classNames = cx(className, 'day', {
        today,
        active,
        disabled,
        highlighted,
    });
    const handleClick = React__namespace.useCallback(() => {
        if (disabled) {
            return;
        }
        onChange?.(date$1);
    }, [date$1, disabled, onChange]);
    return (React__namespace.createElement(Space.Space, { size: 0, align: "center", justify: "center", className: classNames, ...restProps, "data-date": date.getISODate(date$1), onClick: handleClick }, date.getDayFormatted(date$1)));
};
Day.displayName = 'Day';

exports.Day = Day;
//# sourceMappingURL=Day.js.map
